import { render } from "./WatchModel.vue?vue&type=template&id=61918133&scoped=true"
import script from "./WatchModel.vue?vue&type=script&lang=js"
export * from "./WatchModel.vue?vue&type=script&lang=js"

import "./WatchModel.vue?vue&type=style&index=0&id=61918133&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61918133"]])

export default __exports__